/** Roles that can use the admin. The Tablet role is not one of them. */
const ADMIN_ROLES = ['owner', 'admin', 'staff'];

/**
 * Why the admin refuses an account at sign-in, or null to let it in.
 * A Tablet account (role tablet, nothing else) is for the order tablet only.
 */
export function adminSignInRefusal(roles: string[] | undefined): string | null {
  if (roles?.some((r) => ADMIN_ROLES.includes(r))) return null;
  if (roles?.includes('tablet')) return 'This account is for the order tablet only. Sign in on the store’s tablet.';
  return 'This account does not have admin access. Please use the Deeliver app.';
}
